import React from 'react';
import {
  AssessmentQuestion,
  AssessmentQuestionType,
} from './AssessmentQuestionType';
import MultipleChoiceQuestionStep from './MultipleChoiceQuestionStep';
import SingleChoiceQuestionStep from './SingleChoiceQuestionStep';
import TextInputQuestionStep from './TextInputQuestionStep';
import FileUploadQuestionStep from './FileUpoadQuestionStep';
import { AssessmentQuestionAction } from './AssessmentQuestionAction';

interface AssessmentQuestionStepRendererProps {
  data: AssessmentQuestion;
  index: number;
  totalCount: number;
  goNext: () => void;
  goBack: () => void;
  handleSubmit: () => void;
  dispatch: React.Dispatch<AssessmentQuestionAction>;
}

const AssessmentQuestionStepRenderer: React.FC<
  AssessmentQuestionStepRendererProps
> = ({
  data,
  index,
  totalCount,
  goNext,
  goBack,
  handleSubmit,
  dispatch,
}) => {
  // console.log(assessmentId);
  const { type } = data;
  if (type === AssessmentQuestionType.MULTIPLE_CHOICE) {
    return (
      <MultipleChoiceQuestionStep
        data={data}
        index={index}
        isFirst={index === 0}
        isLast={index === totalCount - 1}
        goBack={goBack}
        goNext={goNext}
        handleSubmit={handleSubmit}
        dispatch={dispatch}
      />
    );
  } else if (type === AssessmentQuestionType.SINGLE_CHOICE) {
    return (
      <SingleChoiceQuestionStep
        data={data}
        index={index}
        isFirst={index === 0}
        isLast={index === totalCount - 1}
        goBack={goBack}
        goNext={goNext}
        handleSubmit={handleSubmit}
        dispatch={dispatch}
      />
    );
  } else if (type === AssessmentQuestionType.TEXT) {
    return (
      <TextInputQuestionStep
        data={data}
        index={index}
        isFirst={index === 0}
        isLast={index === totalCount - 1}
        goBack={goBack}
        goNext={goNext}
        handleSubmit={handleSubmit}
        dispatch={dispatch}
      />
    );
  } else if (type === AssessmentQuestionType.FILE_UPLOAD) {
    return (
      <FileUploadQuestionStep
        data={data}
        index={index}
        isFirst={index === 0}
        isLast={index === totalCount - 1}
        goBack={goBack}
        goNext={goNext}
        handleSubmit={handleSubmit}
        dispatch={dispatch}
      />
    );
  }
  return <></>;
};

export default AssessmentQuestionStepRenderer;
